import { get } from 'lodash'
import { required, email, maxLength } from 'utils/validation'

export default function(values) {
  const errors = {
    // title: required(get(values, 'title')),
    firstName: required(get(values, 'firstName')),
    lastName: required(get(values, 'lastName')),
    email: email(get(values, 'email')),
    phone: required(get(values, 'phone')),
    birthDate: required(get(values, 'birthDate')),
    address: {
      line1: required(get(values, 'address.line1')),
      city: required(get(values, 'address.city')),
      zipCode: required(get(values, 'address.zipCode')) || maxLength(20)(get(values, 'address.zipCode')),
      // stateOrProvinceOrRegion: required(get(values, 'address.stateOrProvinceOrRegion')),
      country: {
        id: required(get(values, 'address.country.id'))
      }
    },
    gender: {
      value: required(get(values, 'gender.value'))
    },
    secondaryEmail: email(get(values, 'secondaryEmail'))
    // registrationAwardLevel: {
    //   id: required(get(values, 'registrationAwardLevel.id')),
    // },
  }

  if (get(values, 'helpers.withPostalAddress')) {
    errors.postalAddress = {
      line1: required(get(values, 'postalAddress.line1')),
      city: required(get(values, 'postalAddress.city')),
      zipCode: required(get(values, 'address.zipCode')) || maxLength(20)(get(values, 'address.zipCode')),
      // stateOrProvinceOrRegion: required(get(values, 'address.stateOrProvinceOrRegion')),
      country: {
        id: required(get(values, 'postalAddress.country.id'))
      }
    }
  }

  return errors
}
